import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { ConsumerMoneyOrderHandlerProvider } from '../../providers/consumer-money-order-handler';

import { Globals } from '../../providers/globals';


@Component({
  selector: 'page-consumer-money-order-detail',
  templateUrl: 'consumer-money-order-detail.html',
})
export class ConsumerMoneyOrderDetailPage {
	products: any = []; 
	filePath: any;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams, 
		public globals: Globals,
		public mainProvider: ConsumerMoneyOrderHandlerProvider) {
	}

	ionViewDidLoad() {   
		this.filePath = this.globals.fileUrl;

		this.products = JSON.parse(this.mainProvider.order.GroupJSON);
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-money-order-detail/consumer-money-order-detail.ts